export interface Column<T> {
  header: string;
  /** Rechtsbündig für Zahlen, sonst linksbündig. */
  align?: 'left' | 'right';
  cell: (row: T) => React.ReactNode;
}

/**
 * Tabelle für die Verwaltungsmasken.
 *
 * Bewusst schmal gehalten: keine Sortierung, kein Paging, keine Auswahl. Bei
 * einem Fuhrpark dieser Größe wäre das Beiwerk, das man pflegen muss, ohne dass
 * es je jemand benutzt.
 *
 * Der Rahmen scrollt waagerecht — sonst schiebt eine Tabelle mit vielen Spalten
 * auf schmalen Fenstern die ganze Seite zur Seite.
 */
export function DataTable<T>({
  columns,
  rows,
  rowKey,
  rowClassName,
}: {
  columns: Column<T>[];
  rows: T[];
  rowKey: (row: T) => string;
  rowClassName?: (row: T) => string;
}) {
  return (
    <div className="overflow-x-auto rounded-lg border border-slate-200 bg-white">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-left text-xs uppercase tracking-wide text-slate-500">
            {columns.map((column) => (
              <th
                key={column.header}
                className={['px-4 py-2.5 font-medium', column.align === 'right' ? 'text-right' : ''].join(' ')}
                scope="col"
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={rowKey(row)}
              className={['border-b border-slate-100 last:border-0', rowClassName?.(row) ?? ''].join(' ')}
            >
              {columns.map((column) => (
                <td
                  key={column.header}
                  className={['px-4 py-2.5 align-middle', column.align === 'right' ? 'text-right' : ''].join(' ')}
                >
                  {column.cell(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
